'use client';

import { useEffect } from 'react';
import { gsap } from 'gsap';
import { Draggable } from 'gsap/Draggable';
import Lottie from 'lottie-react';
import petVeryHungryAnimationData from '../animations/very_hungry_pet_game.json';
import petHungryAnimationData from '../animations/hungry_pet_game.json';
import petSickAnimationData from '../animations/sick_pet_game.json';
import petHappyAnimationData from '../animations/happy_pet_game.json';
import { HOBE_HUNGRINESS_THRESHOLDS } from '@/constants/generalConstants';
import useHobe from '@/app/hobe/services/useHobe';
import useNavigateWithAnimation from '@/helpers/useNavigateWithAnimation';
import { usePathname } from 'next/navigation';

const HobeFloatingButton = () => {
    const { hobeData } = useHobe({ fetchHobeData: true });
    const { navigateWithAnimation } = useNavigateWithAnimation();
    const pathname = usePathname();

    useEffect(() => {
        gsap.registerPlugin(Draggable);
    }, []);

    useEffect(() => {
        const setupDraggable = () => {
            const button = document.getElementById('hobe-floating-button');
            const container = document.querySelector('body');

            if (!button || !container) return;

            Draggable.create(button, {
                type: 'x,y',
                bounds: container,
                inertia: true,
                onClick: () => document.getElementById('navigation-element')?.click(),
                onDragEnd: () => {
                    const buttonRect = button.getBoundingClientRect();
                    const containerRect = container?.getBoundingClientRect();
                    const distanceToLeftEdge = buttonRect.left - containerRect.left;
                    const distanceToRightEdge = containerRect.right - buttonRect.right;

                    gsap.to(button, {
                        x:
                            distanceToLeftEdge < distanceToRightEdge
                                ? -(containerRect.right - buttonRect.width - 20)
                                : -containerRect.left,
                        duration: 0.3,
                        ease: 'power2.out'
                    });
                }
            });
        };

        const timeoutId = setTimeout(setupDraggable, 100);
        return () => clearTimeout(timeoutId);
    }, [pathname]);

    const goToHobePage = () => {
        navigateWithAnimation({ link: '/hobe' });
    };

    return (
        <div>
            <span style={{ visibility: 'hidden' }} onClick={goToHobePage} id="navigation-element" />
            <button id="hobe-floating-button" className="hobe-floating-button">
                <span className="hobe-floating-button-animation-container">
                    {hobeData?.user_state?.energy && (
                        <>
                            {
                                // todo: check if it can be brought to a memo
                                hobeData?.user_state?.energy <
                                HOBE_HUNGRINESS_THRESHOLDS.hungrinessThreshold1 ? (
                                    <Lottie animationData={petSickAnimationData} />
                                ) : hobeData?.user_state?.energy <
                                  HOBE_HUNGRINESS_THRESHOLDS.hungrinessThreshold2 ? (
                                    <Lottie animationData={petVeryHungryAnimationData} />
                                ) : hobeData?.user_state?.energy <
                                  HOBE_HUNGRINESS_THRESHOLDS.hungrinessThreshold3 ? (
                                    <Lottie animationData={petHungryAnimationData} />
                                ) : (
                                    <Lottie animationData={petHappyAnimationData} />
                                )
                            }
                        </>
                    )}
                </span>
            </button>
        </div>
    );
};

HobeFloatingButton.displayName = 'HobeFloatingButton';

export default HobeFloatingButton;
